<ng-container *ngIf="(dialogType === 'mismatch_time_zone')">
    <div class="countable-dialog w-100" style="max-width: 400px;">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">{{dialogHeader}}</h4>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-16 mt-2 mb-32">

            <p class="text-gray-6"> We've detected a time zone mismatch, which may affect displayed information</p>
            <p class="align-items-start bg-gray-1 br-6 p-1">
                Default Time Zone: {{dialogData?.zoneNameUi}}
            </p>
            <p class="text-gray-6">Do you wish to update the time zone or keep the default?
            </p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button mat-stroked-button color="dark" class="button-medium" [mat-dialog-close]="false">Keep
                Default
            </button>
            <button [mat-dialog-close]="true" mat-button mat-flat-button color="primary" class="button-medium">Update
                Time Zone
            </button>
        </div>
    </div>
</ng-container>
